import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {networkServicesPrivacyPolicy} from '#/lib/policies'
import {PolicyDocument} from '#/components/PolicyDocument'

type Props = NativeStackScreenProps<
  CommonNavigatorParams,
  'NetworkServicesPrivacyPolicy'
>
export const NetworkServicesPrivacyPolicyScreen = (_props: Props) => {
  return <PolicyDocument {...networkServicesPrivacyPolicy} />
}
